var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgList28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.14291 10.2857C6.72087 10.2857 8.00005 9.00654 8.00005 7.42858C8.00005 5.85063 6.72087 4.57144 5.14291 4.57144C3.56495 4.57144 2.28577 5.85063 2.28577 7.42858C2.28577 9.00654 3.56495 10.2857 5.14291 10.2857Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4286 5.7143C10.4818 5.7143 9.71434 6.48181 9.71434 7.42858C9.71434 8.37536 10.4818 9.14287 11.4286 9.14287H28.0001C28.9468 9.14287 29.7143 8.37536 29.7143 7.42858C29.7143 6.48181 28.9468 5.7143 28.0001 5.7143H11.4286Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.14291 19.4286C6.72087 19.4286 8.00005 18.1494 8.00005 16.5714C8.00005 14.9935 6.72087 13.7143 5.14291 13.7143C3.56495 13.7143 2.28577 14.9935 2.28577 16.5714C2.28577 18.1494 3.56495 19.4286 5.14291 19.4286Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4286 14.8572C10.4818 14.8572 9.71434 15.6247 9.71434 16.5714C9.71434 17.5182 10.4818 18.2857 11.4286 18.2857H28.0001C28.9468 18.2857 29.7143 17.5182 29.7143 16.5714C29.7143 15.6247 28.9468 14.8572 28.0001 14.8572H11.4286Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00005 25.7143C8.00005 27.2923 6.72087 28.5714 5.14291 28.5714C3.56495 28.5714 2.28577 27.2923 2.28577 25.7143C2.28577 24.1363 3.56495 22.8572 5.14291 22.8572C6.72087 22.8572 8.00005 24.1363 8.00005 25.7143Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.71434 25.7143C9.71434 24.7675 10.4818 24 11.4286 24H28.0001C28.9468 24 29.7143 24.7675 29.7143 25.7143C29.7143 26.6611 28.9468 27.4286 28.0001 27.4286H11.4286C10.4818 27.4286 9.71434 26.6611 9.71434 25.7143Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList28);
export default __webpack_public_path__ + "static/media/list_28.c8a0455e.svg";
export { ForwardRef as ReactComponent };